import { __awaiter, __extends, __generator, __read, __spreadArray } from "tslib";
import { DomainError } from "../DomainError";
import { Optional } from "../Optional";
import { Fail, Success } from "./Result";
var ResultTimeout = (function (_super) {
    __extends(ResultTimeout, _super);
    function ResultTimeout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.message = "Exceeded Timeout";
        return _this;
    }
    return ResultTimeout;
}(DomainError));
export { ResultTimeout };
var AsyncResult = (function () {
    function AsyncResult(promise) {
        this.promise = promise;
    }
    AsyncResult.wrap = function (fn) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return AsyncResult.fromPromise((function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
                return [2, fn.apply(void 0, __spreadArray([], __read(args), false))];
            }); }); })());
        };
    };
    AsyncResult.prototype.then = function (onfulfilled, _onrejected) {
        return this.promise.then(onfulfilled, function (err) {
            var fail = Fail.of(err);
            if (onfulfilled) {
                onfulfilled(fail);
            }
            return fail;
        });
    };
    AsyncResult.fail = function (error) {
        return AsyncResult.fromPromise(Promise.reject(error));
    };
    AsyncResult.success = function (value) {
        return AsyncResult.fromPromise(Promise.resolve(value));
    };
    AsyncResult.fromPromise = function (promise) {
        return new AsyncResult(promise.then(Success.of).catch(Fail.of));
    };
    AsyncResult.unwrapResult = function (promise) {
        return new AsyncResult(promise);
    };
    AsyncResult.prototype.withTimeout = function (ms, error) {
        var _this = this;
        return AsyncResult.fromPromise((function () { return __awaiter(_this, void 0, void 0, function () {
            var timeoutMarker, timeout;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        timeout = new Promise(function (_, rej) {
                            timeoutMarker = setTimeout(function () {
                                return rej(error !== null && error !== void 0 ? error : new ResultTimeout("Timeout of ".concat(ms, " milliseconds exceeded")));
                            }, ms);
                        });
                        return [4, Promise.race([this, timeout])];
                    case 1:
                        _b.sent();
                        clearTimeout(timeoutMarker);
                        return [2, this.getOrThrowFailure()];
                }
            });
        }); })());
    };
    AsyncResult.prototype.getOrThrowFailure = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this];
                    case 1: return [2, (_b.sent()).getOrThrowFailure()];
                }
            });
        });
    };
    AsyncResult.prototype.getEither = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this];
                    case 1: return [2, (_b.sent()).getEither()];
                }
            });
        });
    };
    AsyncResult.prototype.tap = function (mapSuccess, mapError) {
        return new AsyncResult(this.then(function (result) { return result.tap(mapSuccess, mapError); }));
    };
    AsyncResult.prototype.tapAsync = function (mapSuccess, mapError) {
        return new AsyncResult(this.then(function (result) { return result.tapAsync(mapSuccess, mapError); }));
    };
    AsyncResult.prototype.map = function (mapSuccess, mapError) {
        return new AsyncResult(this.then(function (result) { return result.map(mapSuccess, mapError); }));
    };
    AsyncResult.prototype.mapAsync = function (mapSuccess, mapError) {
        return new AsyncResult(this.then(function (result) { return result.mapAsync(mapSuccess, mapError); }));
    };
    AsyncResult.prototype.flatMap = function (mapSuccess, mapError) {
        var _this = this;
        return AsyncResult.unwrapResult(this.then(function (result) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
            return [2, result.flatMap(mapSuccess, mapError)];
        }); }); }));
    };
    AsyncResult.prototype.flatMapAsync = function (mapSuccess, mapError) {
        var _this = this;
        return AsyncResult.unwrapResult(this.then(function (result) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
            return [2, result.flatMapAsync(mapSuccess, mapError)];
        }); }); }));
    };
    AsyncResult.prototype.toOptionalFailure = function () {
        var _this = this;
        return Optional.of(true).flatMapAsync(function () {
            return _this.then(function (result) { return result.toOptionalFailure(); });
        });
    };
    AsyncResult.prototype.toOptional = function () {
        var _this = this;
        return Optional.of(true).flatMapAsync(function () {
            return _this.then(function (result) { return result.toOptional(); });
        });
    };
    AsyncResult.prototype.mergeFailure = function (mapFailure) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2, this.then(function (r) { return r.mergeFailure(mapFailure); })];
            });
        });
    };
    AsyncResult.prototype.mapFailure = function (mapFailure) {
        return new AsyncResult(this.then(function (result) { return result.mapFailure(mapFailure); }));
    };
    var _a;
    _a = AsyncResult;
    AsyncResult.invoke = function (fn) {
        return AsyncResult.fromPromise((function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(_a, function (_b) {
            return [2, fn()];
        }); }); })());
    };
    return AsyncResult;
}());
export { AsyncResult };
